import React, { useState, useEffect } from 'react';
import { Col, Row, Button, Card } from 'tea-component';
import { fetchGamesOwned } from '@/pages/intelligence/services/companies';
import moment from 'moment';
import { useIntl, connect } from 'umi';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import GamesContext from './GamesContext';
import Filter from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/Sizer/GamesOwnedFilter';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import { toLowerArr } from './_utils';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import DetailDownload from '@/pages/intelligence/pages/TopCharts/Companies/components/GamesDetails/GamesStats/components/DetailDownload';
import { getCountriesExtendParams } from '@intelligence/utils/filterUtils';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useFilterExtend from '@/pages/intelligence/hooks/useFilterExtend';
import { COMBINEID_REG } from '@intelligence/utils/constant';

interface GAMESTYPE {
  mobile?: any;
  pc?: any;
  console?: any;
  [key: string]: any;
}
const pageSearchInfo = {
  page: 1,
  page_size: 15,
};

const entityConditionsMobielPC = [
  {
    entity: 'mobile',
    app_name: '',
    page: pageSearchInfo.page,
    page_size: pageSearchInfo.page_size,
  },
  {
    entity: 'pc',
    app_name: '',
    page: pageSearchInfo.page,
    page_size: pageSearchInfo.page_size,
  },
];
const entityConditionsConsole = [
  {
    entity: 'console',
    app_name: '',
    page: pageSearchInfo.page,
    page_size: pageSearchInfo.page_size,
  },
];

const GamesOwned = (props: any) => {
  const { filterState, companyId, tabId, gameName } = props;

  // 加载状态
  const [loading, setLoading] = useState(true);
  const [inMobileLoading, setinMobileLoading] = useState(false);
  const [inPcLoading, setinPcLoading] = useState(false);
  const [inConsoleLoading, setinConsoleeLoading] = useState(false);
  const [fetchParams, setFetchParams] = useState({
    company_id: companyId,
    entity_conditions: entityConditionsMobielPC,
    region_type: 'region',
    regions: toLowerArr(['global']), // 要全转为小写
    sub_genre: [],
  });

  const { isOperateDetail, detailFilterExtend, setDetailFilterExtend } = useFilterExtend({});
  const [regionOptions, setRegionOptions] = useState([]);
  const [filterLoading, setFilterLoading] = useState(true);

  const [downloadParamsOwn, setDownloadParamsOwn] = useState({});
  // 用于判断是否给子组件传递total
  const [searchType, setSearchType] = useState('whole');

  // 游戏内容详情数据
  const [mobielGame, setMobileGame] = useState({});
  const [mobileTotal, setMobileTotal] = useState(0);
  const [mobilePartTotal, setMobilePartTotal] = useState(0);

  const [pcGame, setPcGame] = useState({});
  const [pcTotal, setPcTotal] = useState(0);
  const [pcPartTotal, setPcPartTotal] = useState(0);
  const [searchMobileValue, setSearchMobileValues] = useState('');
  const [searchPcValue, setSearchPCValues] = useState('');
  const [searchConsoleValue, setSearchConsoleValues] = useState('');

  const [consoleGame, setConsoleGame] = useState({});
  const [consoleTotal, setConsoleTotal] = useState(0);
  const [consolePartTotal, setConsolePartTotal] = useState(0);

  // 检索名称
  // const [searchName, setSearchName] = useState('');
  const [currentType, setCurrentType] = useState('');
  //
  const [searchApp, setSearchApp] = useState<GAMESTYPE>({
    mobile: '',
    pc: '',
    console: '',
  });

  const [searchPage, setSearchPage] = useState<GAMESTYPE>({
    mobile: pageSearchInfo,
    pc: pageSearchInfo,
    console: pageSearchInfo,
  });

  // Annie数据源格式化处理
  const transformAnnie = (arr = []) => {
    const _annieSource: any = [];
    arr?.forEach((item: any, index: number) => {
      const _singleAnnie = {};
      _singleAnnie.genre = item?.genre || '';
      _singleAnnie.sub_genre = item?.sub_genre || [];
      _annieSource.push(_singleAnnie);
    });
    return _annieSource;
  };

  // 获取三大类型中返回的时间最早的一个
  const getMinMetricDate = (dateList: any) => {
    const tempList = [];
    for (const n in dateList) {
      if (dateList[n] && dateList[n] != '' && dateList[n] != '1970-01-01') {
        tempList.push(new Date(dateList[n]).getTime());
      }
    }
    return moment(Math.min(...tempList)).format('YYYY-MM-DD');
  };

  // 检索
  const searchGame = (param1: string, type: string) => {
    setSearchType('part');
    const obj: GAMESTYPE = {};
    obj[`${type}`] = param1;
    setCurrentType(type);
    const data = Object.assign({}, searchApp, obj);
    setSearchApp(data);
    getPartGame(data, false, type);
  };
  const receiveGameType = (param: any) => {
    // setCurrentType(param);
  };

  // 接收分页的参数
  const onPagingChange = (param: any, val: any) => {
    setSearchType('part');
    setCurrentType(val);

    const obj: GAMESTYPE = {};
    const initPage = {
      page: param?.pageIndex || 1,
      page_size: param?.pageSize || 15,
    };
    obj[`${val}`] = initPage;
    const data = Object.assign({}, searchPage, obj);
    setSearchPage(data);
    getPartGame(false, data, val);
  };

  // 全局-筛选器检索
  const getAllGames = async (params) => {
    // 添加ID校验规则
    if (COMBINEID_REG.test(companyId)) {
      setLoading(true);
      // 游戏详情数据设置
      try {
        const res = await Promise.allSettled([
          fetchGamesOwned({
            ...params,
            entity_conditions: entityConditionsMobielPC,
          }),
          fetchGamesOwned({
            ...params,
            entity_conditions: entityConditionsConsole,
          }),
        ]);
        let res1 = null;
        let res2 = null;
        if (res[0].status === 'fulfilled') {
          res1 = res[0].value;
        }
        if (res[1].status === 'fulfilled') {
          res2 = res[1].value;
        }
        const { mobile = {}, pc = {} } = res1?.data;
        const { console = {} } = res2?.data;
        setMobileGame(mobile);
        setMobileTotal(mobile?.total || 0);
        setPcGame(pc);
        setPcTotal(pc?.total || 0);
        setConsoleGame(console);
        setConsoleTotal(console?.total || 0);

        setMobilePartTotal(mobile?.total || 0);
        setPcPartTotal(pc?.total || 0);
        setConsolePartTotal(console?.total || 0);

        const minMetricDate = getMinMetricDate([
          mobile?.metric_date,
          pc?.metric_date,
          console?.metric_date,
        ]);
        setDownloadParamsOwn({
          ...params,
          entity_conditions: [...entityConditionsMobielPC, ...entityConditionsConsole],
          start_date:
            moment(minMetricDate).subtract(5, 'month').format('YYYY-MM-DD') ||
            moment().subtract(5, 'month').format('YYYY-MM-DD'),
          end_date: minMetricDate || moment().format('YYYY-MM-DD'),
        });
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    }
  };

  // 局部-模糊，分页检索
  const getPartGame = async (nameSearch = false, pageSearch = false, type: string) => {
    // setinsideLoading(true);
    if (type === 'mobile') {
      setinMobileLoading(true);
    }
    if (type === 'pc') {
      setinPcLoading(true);
    }
    if (type === 'console') {
      setinConsoleeLoading(true);
    }

    const conditionParam = {
      ...fetchParams,
      entity_conditions: [
        {
          entity: type ? type : currentType,
          app_name: nameSearch ? nameSearch[type] : searchApp[type],
          page: pageSearch ? pageSearch[type]?.page : searchPage[type]?.page,
          page_size: pageSearch ? pageSearch[type]?.page_size : searchPage[type]?.page_size,
        },
      ],
    };
    try {
      const result = await fetchGamesOwned(conditionParam);
      const { console: consoles = {}, mobile = {}, pc = {} } = result?.data;
      setDownloadParamsOwn({
        ...downloadParamsOwn,
        entity_conditions: [
          ...downloadParamsOwn.entity_conditions?.filter((item: any) => item.entity !== type),
          ...conditionParam.entity_conditions,
        ],
      });
      if (type === 'mobile') {
        // console.log('result', result);
        setMobileGame(mobile || []);
        // setMobilePartTotal(mobile?.total || 0);
        setinMobileLoading(false);
        !mobile.games && setSearchPage({ mobile: pageSearchInfo });
      }
      if (type === 'pc') {
        setPcGame(pc || []);
        setPcPartTotal(pc?.total || 0);
        setinPcLoading(false);
        !pc.games && setSearchPage({ pc: pageSearchInfo });
      }
      if (type === 'console') {
        setConsoleGame(consoles || []);
        setConsolePartTotal(consoles?.total || 0);
        setinConsoleeLoading(false);
        !consoles.games && setSearchPage({ console: pageSearchInfo });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (!filterLoading) {
      let newFetchParams = {
        ...fetchParams,
      };
      if (isOperateDetail === true) {
        /** 获取继承参数 */
        const extendParams = getExtendParams();
        newFetchParams = { ...newFetchParams, ...extendParams };
      }
      setFetchParams(newFetchParams);
      getAllGames(newFetchParams);
    }
  }, [filterLoading]);

  const formatRegionParams = (markets: string[]) => {
    // 不同国家国家取交集,并且把交集的结果重新赋值到继承值中
    const { regionValues, filterExtendValue } = getCountriesExtendParams({
      regionOptions, // 国家筛选器options,
      defalutMarket: ['global'], // 没取到交集用的默认值
      disableNoChina: true,
      markets,
      filterExtend: detailFilterExtend,
    });
    setDetailFilterExtend(filterExtendValue);
    return regionValues;
  };

  const getExtendParams = () => {
    const newFetchParams: any = {};
    const marketExtend = detailFilterExtend[filterKeyMap.REGION];
    if (marketExtend) {
      const regionValues = formatRegionParams(marketExtend?.markets);
      newFetchParams.region_type = regionValues?.regionType;
      newFetchParams.regions = regionValues?.regions;
    }

    return newFetchParams;
  };

  const handleConfirm = (value: any) => {
    const newFetchParams = { ...fetchParams, ...value };
    getAllGames(newFetchParams);
    setSearchMobileValues('');
    setSearchPCValues('');
    setSearchConsoleValues('');
  };

  const onFilterInit = (params: any) => {
    const { loading, regionOptions } = params || {};
    setFilterLoading(loading);
    setRegionOptions(regionOptions);
  };

  return (
    <div className="dbi-games-owned">
      <div className="dbi-statsfilter-warp">
        <div className="statsfilter-warp-left">
          <Filter
            timeFilterValues={{}}
            buttonLogConfig={{}}
            filterConfirm={handleConfirm}
            filterReset={() => {}}
            filterInit={() => {}}
            companyId={companyId}
            onFilterInit={onFilterInit}
          />
        </div>
        <div className="dbi-statsfilter-warp-right">
          <DetailDownload
            entityType={'mobile'}
            mainLoading={loading}
            downloadParamsOwn={downloadParamsOwn}
            segpaVa={'gamesOwned'}
            gameName={gameName}
            segment={'gamesOwned'}
          />
        </div>
      </div>
      <div style={{ height: 20 }}></div>

      {loading || (mobileTotal == 0 && pcTotal == 0 && consoleTotal == 0) ? (
        <Card className="game-owned__section">
          <Card.Body>
            <CardStats
              cardStatus={{
                isLoading: loading,
                isError: false,
                isNoData: mobileTotal == 0 && pcTotal == 0 && consoleTotal == 0,
              }}
            />
          </Card.Body>
        </Card>
      ) : (
        <Row>
          {/* mobileGames */}
          {mobileTotal != 0 ? (
            <Col key={'mobile'} span={24}>
              <CardSlot>
                <GamesContext
                  gameType="mobile"
                  title={'Mobile Games'}
                  gameDetail={mobielGame}
                  wholeTotal={mobileTotal}
                  pageTotal={mobilePartTotal}
                  searchGame={searchGame}
                  receiveGameType={receiveGameType}
                  searchValue={searchMobileValue}
                  setSearchValues={setSearchMobileValues}
                  onPagingChange={onPagingChange}
                  loading={inMobileLoading}
                />
              </CardSlot>
            </Col>
          ) : (
            <></>
          )}
          {/* PcGames */}
          {pcTotal != 0 ? (
            <Col key={'pc'} span={24}>
              <CardSlot>
                <GamesContext
                  gameType="pc"
                  title={'PC Games'}
                  gameDetail={pcGame}
                  wholeTotal={pcTotal}
                  pageTotal={pcPartTotal}
                  searchGame={searchGame}
                  receiveGameType={receiveGameType}
                  searchValue={searchPcValue}
                  setSearchValues={setSearchPCValues}
                  onPagingChange={onPagingChange}
                  loading={inPcLoading}
                />
              </CardSlot>
            </Col>
          ) : (
            <></>
          )}
          {/* consoleGames */}
          {consoleTotal != 0 ? (
            <Col key={'console'} span={24}>
              <CardSlot>
                <GamesContext
                  gameType="console"
                  title={'Console Games'}
                  gameDetail={consoleGame}
                  wholeTotal={consoleTotal}
                  pageTotal={consolePartTotal}
                  searchGame={searchGame}
                  receiveGameType={receiveGameType}
                  searchValue={searchConsoleValue}
                  setSearchValues={setSearchConsoleValues}
                  onPagingChange={onPagingChange}
                  loading={inConsoleLoading}
                />
              </CardSlot>
            </Col>
          ) : (
            <></>
          )}
        </Row>
      )}
    </div>
  );
};

export default connect((state: any) => {
  return {
    filterState: state[FILTER_EXTEND_NAMESPACE],
  };
})(GamesOwned);
